import {Injectable} from '@angular/core';
import {Observable} from "rxjs";
import {Store} from "@ngrx/store";

import {
  INavigationApplicationInterface,
  INavigationConfigurationInterface,

} from "@ispm/navigation/interfaces";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {NavigationConfigService} from "@ispm/navigation/services/navigationConfig.service";

@Injectable()
export class WebConfigService {
  constructor(
    private store: Store<IgenomicsState>,
    private navigationConfigService: NavigationConfigService
  ) {
  }

  public getWebConfiguration(): Observable<INavigationConfigurationInterface> {
    return this.navigationConfigService.getWebConfiguration();
  }

  public getCurrentAppLocalization(app:INavigationApplicationInterface): Observable<any> {
    return this.navigationConfigService.getCurrentAppLocalization(app);
  }

  public getCurrentApplication(): Observable<any> {
    return this.navigationConfigService.getCurrentApplication();
  }
}
